__turbopack_context__.v({
  "mapZoomButton": "_96UAHq_mapZoomButton",
  "scrollButton": "_96UAHq_scrollButton",
  "scrollButtonWrapper": "_96UAHq_scrollButtonWrapper",
  "scrollButtonWrapperLeft": "_96UAHq_scrollButtonWrapperLeft",
  "scrollButtonWrapperRight": "_96UAHq_scrollButtonWrapperRight",
  "skiAreaSection": "_96UAHq_skiAreaSection",
  "tab": "_96UAHq_tab",
  "tabActive": "_96UAHq_tabActive",
  "tabBar": "_96UAHq_tabBar",
  "tabBarSlider": "_96UAHq_tabBarSlider",
  "tabBarWrapper": "_96UAHq_tabBarWrapper",
  "tabContent": "_96UAHq_tabContent",
  "tabDetails": "_96UAHq_tabDetails",
  "tabMap": "_96UAHq_tabMap",
});
